<p-toast position="top-right"></p-toast>
<div class="ui-g">
  <div class="ui-g-12">
    <div class="card card-w-title">
      <h1>{{setLabel("membersAccountsLabel")}}</h1>
      <p-dataView #ev [value]="members" [paginator]="true" [rows]="5" [loading]="loading">
        <p-header>
          <div class="ui-helper-clearfix">
            <div class="ui-g">
              <div class="ui-g-11 ui-md-11">
                <div class="ui-g-3">
                  <input pinputtext="" [placeholder]='setLabel("searchByNamePlaceholderLabel")' type="text" name="name" [(ngModel)]="member.name"
                    (keyup)="searchLocal(member.name, 'name')"
                    class="ui-inputtext ui-corner-all ui-state-default ui-widget">
                </div>
                <div class="ui-g-3">
                  <input pinputtext="" [placeholder]='setLabel("searchByMemberShipPlaceholderLabel")' type="number" name="tag"
                    (keyup)="searchLocal(member.tagNumber, 'tagNumber')" [(ngModel)]="member.tagNumber"
                    class="ui-inputtext ui-corner-all ui-state-default ui-widget">
                </div>
                <div class="ui-g-3">
                  <input pinputtext="" [placeholder]='setLabel("searchByContactPlaceholderLabel")' type="number" name="contact"
                    [(ngModel)]="member.contactDetail.contact"
                    (keyup)="searchLocal(member.contactDetail.contact, 'contact')"
                    class="ui-inputtext ui-corner-all ui-state-default ui-widget">
                </div>
                <div class="ui-g-3">
                  <input pinputtext="" [placeholder]='setLabel("searchByEmailPlaceholderLabel")' type="text"
                    (keyup)="searchLocal(member.email, 'email')" name="email" [(ngModel)]="member.email"
                    class="ui-inputtext ui-corner-all ui-state-default ui-widget">
                </div>
              </div>
              <div class="ui-g-1 ui-md-1" style="text-align:right">
                <p-dataViewLayoutOptions></p-dataViewLayoutOptions>
              </div>
              <div class="ui-g-12">
                <button (click)="clear()"
                  class="ui-button-warn ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"><i
                    class="fa fa-eraser"></i>&nbsp;{{setLabel("clearSearchLabel")}}</button>&nbsp;
                <!-- <button (click)="search()"
                  class="ui-button-warn ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only"><i
                    class="fa fa-search"></i>&nbsp;Search</button>&nbsp; -->
              </div>
            </div>
          </div>
        </p-header>
        <ng-template let-member pTemplate="listItem">
          <div class="ui-g" style="padding: 2em;border-bottom: 1px solid #d9d9d9">
            <div class="ui-g-12 ui-md-2" style="text-align:center">
              <img width="100%" [src]="member.profile" />
            </div>
            <div class="ui-g-12 ui-md-8 car-details">
              <div class="ui-g">
                <div class="ui-g-6 ui-sm-6">{{setLabel("membershipNumberLabel")}}</div>
                <div class="ui-g-6 ui-sm-6">
                  <b>{{member.tagNumber}}</b>
                </div>
                <div class="ui-g-6 ui-sm-6">{{setLabel("nameLabel")}}</div>
                <div class="ui-g-6 ui-sm-6">
                  <b>{{member.name}}</b>
                </div>
                <div class="ui-g-6 ui-sm-6">{{setLabel("emailLabel")}}</div>
                <div class="ui-g-6 ui-sm-6">
                  <b>{{member.email}}</b>
                </div>
                <div class="ui-g-6 ui-sm-6">{{setLabel("contactLabel")}}</div>
                <div class="ui-g-6 ui-sm-6">
                  <b>{{member.contactDetail.contact}}</b>
                </div>
              </div>
            </div>
            <div class="ui-g-12 ui-md-2 search-icon">
              <button pButton type="button" class="ui-button-danger ui-button" icon="fa fa-times"
                (click)="deleteMember(member)"></button>
              <button pButton type="button" icon="fa fa-pencil-square-o" (click)="viewMember(member)"></button>
              <button pButton type="button" class="ui-button-success ui-button" icon="fa fa-money"
                (click)="showDialog(member)"></button>
            </div>
          </div>
        </ng-template>
        <ng-template let-member pTemplate="gridItem">
          <div style="padding:.5em" class="ui-g-12 ui-md-3">
            <p-panel [header]='setLabel("courseHeaderLabel")' [style]="{'text-align':'center'}">
              <div class="car-detail">
                <b>{{member.tagNumber}}</b>
              </div>
              <div class="car-detail">
                <b>{{member.name}}</b>
              </div>
              <div class="car-detail" style="word-break: break-word;">{{member.email}}</div>
              <div class="car-detail">{{member.contactDetail.contact}}</div>
              <hr class="ui-widget-content" style="border-top:0">
              <button pButton type="button" class="ui-button-danger ui-button" icon="fa fa-times"
                (click)="deleteMember(member)" style="margin-top:0"></button>
              <button pButton type="button" icon="fa fa-pencil-square-o" (click)="viewMember(member)"></button>
              <button pButton type="button" class="ui-button-primary ui-button" icon="fa fa-money"
                (click)="showDialog(member)"></button>
            </p-panel>
          </div>
        </ng-template>
      </p-dataView>
    </div>
  </div>
</div>
<p-dialog [header]='setLabel("payFundHeaderLabel")' [(visible)]="dialogVisibility">
  <form #feeForm="ngForm">
    <div class="ui-g-12 ui-md-12">
      <div class="ui-inputgroup">
        <span class="ui-inputgroup-addon">{{setLabel("pKRLabel")}} </span>
        <input type="number" required pattern="[0-9]+" autocomplete="off" pInputText [placeholder]='setLabel("pricePlaceholderLabel")' name="feePay"
          [(ngModel)]="fund.pay" #feePay="ngModel"
          [ngClass]="feePay.invalid && (feePay.dirty || feePay.touched) ? 'errorInput' : '' ">
        <span class="ui-inputgroup-addon">.00</span>
      </div>
      <div *ngIf="feePay.invalid && (feePay.dirty || feePay.touched)">
        <div *ngIf="feePay.errors.required" class="errorShow">
         {{setLabel("pleaseEnterFeeCorrectlyLabel")}}
        </div>
        <div *ngIf="feePay.errors.pattern" class="errorShow">
         {{setLabel("pleaseEnterFeeCorrectlyLabel")}}
        </div>
      </div>
    </div>
    <p-footer>
      <button (click)="addFund()" [disabled]="!feeForm.valid" pButton type="button" label="Save" icon="pi pi-save"
        class="ui-button-success"></button>
    </p-footer>
  </form>
</p-dialog>
<div id="invoice" style="display: none;">
  <div class="invoice-box" style="padding: 0px !important; max-width: 270px !important; margin: 0 !important;">
    <table cellpadding="0" cellspacing="0">
      <tr class="top">
        <td colspan="4">
          <table>
            <tr>
              <td class="title">
                <img [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
                  alt="Company Logo" style="width:100%; max-width:200px;margin-left: 20px;">
              </td>
            </tr>
            <tr>
              <td style="text-align: center !important;">
                <small>{{setLabel("cell:Label")}} {{company.phone}}<br />{{company.address}}</small><br />
                {{setLabel("created:Label")}} {{fund.date | date: 'dd/MM/yyyy'}}
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr class="information">
        <td colspan="4">
          <table>
            <tr>
              <td></td>
              <td style="text-align: left !important">
                {{member.name}}<br> Membership Number:{{member.tagNumber}}<br>
                {{member.email}}<br> {{member.contactDetail.contact}}
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr class="heading">
        <td>{{setLabel("invoiceLabel")}}</td>
        <td>{{setLabel("payLabel")}}</td>
        <td>{{setLabel("dateLabel")}}</td>
        <td>{{setLabel("statusLabel")}}</td>
      </tr>
      <tr class="item" v-for="item in items">
        <td style="padding: 0 !important;">{{fund.invoice}}</td>
        <td style="padding: 0 !important;">{{setLabel("pKRLabel")}} {{fund.pay}}</td>
        <td style="padding: 0 !important;">{{fund.date}}</td>
        <td style="padding: 0 !important;">{{fund.status}}</td>
      </tr>
    </table>
  </div>
</div>